export default __webpack_public_path__ + "static/media/bad-bot.c24e6d41.svg";